'use client'

import CircleSeparator from '@components/Ackodrive/common/CircleSeparator'
import { getFullFormattedDate } from './utils'
import { DateRootContainer, DateText, SeparatorWrapper } from './styles'

const DateComponent = ({ createdAt, updatedAt }) => (
  <DateRootContainer>
    <DateText>{`Published on ${getFullFormattedDate(createdAt)}`}</DateText>
    <SeparatorWrapper>
      <CircleSeparator />
    </SeparatorWrapper>
    <DateText>{`Updated on ${getFullFormattedDate(updatedAt)}`}</DateText>
  </DateRootContainer>
)

export default DateComponent
